import { render } from "./VehicleTypeGroupPeriods.vue?vue&type=template&id=267316ef"
import script from "./VehicleTypeGroupPeriods.vue?vue&type=script&lang=ts"
export * from "./VehicleTypeGroupPeriods.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QInput,QField,QIcon});
